import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data9_4, dataTitle, dataContent } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Table1 from "./9-4-2";
import computeNum from './compute';

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            note: {
                note: ""
            },
            loadingSave: false,
            print: false,
            data1: [],
            dataTitle: []
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        data[5].system = data.reduce((a, b) => {
            if (b.name != 'Total') {
                a += numConvert(b.system)
            }
            return a
        }, 0);

        data[5].stock = data.reduce((a, b) => {
            if (b.name != 'Total') {
                a += numConvert(b.stock)
            }
            return a
        }, 0);

        data[5].system = (data[5].system).toFixed(0);
        data[5].stock = (data[5].stock).toFixed(0);

        for (let i = 0; i < 5; i++) {
            data[i].diff = (numConvert(data[i].stock) - numConvert(data[i].system)).toFixed(0);
        }

        data[5].diff = data.reduce((a, b) => {
            if (b.name != 'Total') {
                a += numConvert(b.diff)
            }
            return a
        }, 0);

        data[5].diff = (data[5].diff).toFixed(0);

        for (let i = 0; i < 6; i++) {
            data[i].percent = (numConvert(data[i].system) == 0 ? 0 : (numConvert(data[i].diff) / numConvert(data[i].system))).toFixed(4);
        }

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data9_4);
        let data = JSON.parse(dataBegin);

        const dataBeginTitle = JSON.stringify(dataTitle);
        let data2 = JSON.parse(dataBeginTitle);

        const dataBeginContent = JSON.stringify(dataContent);
        let data1 = JSON.parse(dataBeginContent);

        fetch(`/_9_4_allInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.table && x.data.table.length > 0) {
                data = x.data.table;
            }

            if (x.data.dataTitle && x.data.dataTitle.length > 0) {
                data2 = x.data.dataTitle;
            }

            if (x.data.dataContent && x.data.dataContent.length > 0) {
                data1 = x.data.dataContent;
            }

            this.setState({ loading: false, dataTitle: data2, data1: computeNum(data1, data2), note: { ...x.data.note[0] } });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        let data2 = this.state.dataTitle.map(x => ({ ...x, year, month }));
        let data1 = this.state.data1.map(x => ({ ...x, year, month }));
        dataFrom.append('data', JSON.stringify({ data, note: [{ ...this.state.note, year, month }], dataTitle: data2, dataContent: data1 }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_9_4', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_4', 1.5, '9.40', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    onChildChange = (name, value) => {
        this.setState({ [name]: value });
    }

    onFillLastMonth = () => {
        if (this.state.data[0] && this.state.data[0].id) {
            message.error('当前月份数据已存在!');
            return
        }
        this.setState({
            data: [],
            data1: [],
            dataTitle: [],
            loading: true,
            note: { note: "" }
        });
        const dataBegin = JSON.stringify(data9_4);
        let data = JSON.parse(dataBegin);

        const dataBeginTitle = JSON.stringify(dataTitle);
        let data2 = JSON.parse(dataBeginTitle);

        const dataBeginContent = JSON.stringify(dataContent);
        let data1 = JSON.parse(dataBeginContent);

        const date = moment(this.state.date).subtract(1, 'month').format('YYYY-MM');

        fetch(`/_9_4_allInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.table && x.data.table.length > 0) {
                data = x.data.table.map(x => {
                    delete x.id;
                    return x
                });
            }

            if (x.data.dataTitle && x.data.dataTitle.length > 0) {
                data2 = x.data.dataTitle.map(x => {
                    delete x.id;
                    return x
                });;
            }

            if (x.data.dataContent && x.data.dataContent.length > 0) {
                data1 = x.data.dataContent.map(x => {
                    delete x.id;
                    return x
                });;
            }

            this.setState({ loading: false, dataTitle: data2, data1: computeNum(data1, data2), note: { ...x.data.note[0] } });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Items 项目',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>Amount<br />System 系统数</div>,
            dataIndex: 'system',
            key: 'system',
            align: "center",
            render: (text, record, index) => {
                if (index <= 4) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={0}
                                className="table_numInput"
                                defaultValue={text == 0 ? "" : text}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(0));
                                    this.onChange('system', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }
            }
        }, {
            title: <div>Amount<br />Stock taken 盘点数</div>,
            dataIndex: 'stock',
            key: 'stock',
            align: "center",
            render: (text, record, index) => {
                if (index <= 4) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={0}
                                className="table_numInput"
                                defaultValue={text == 0 ? "" : text}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(0));
                                    this.onChange('stock', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }
            }
        }, {
            title: <div>Diff 差异</div>,
            dataIndex: 'diff',
            key: 'diff',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} >
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )
            }
        }, {
            title: '% 百分比',
            dataIndex: 'percent',
            align: "center",
            key: 'percent',
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} >
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                    </div>
                )
            }
        }, {
            title: <div>GM/DOF Comments<br />总经理及财务总监备注</div>,
            dataIndex: 'note',
            key: 'note',
            align: "center",
            render: (text, record, index) => {
                if (index <= 4) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    let data = this.state.data;
                                    data[index].note = e.target.value;
                                    this.setState({
                                        data
                                    });
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} style={{ textAlign: "center" }}>
                            -
                        </div>
                    )
                }
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table9_4">
                        <Row>9.4.1 Operating Equipment Stock taken Summary 营运工具盘点汇总 (at least Quarterly)</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        data1: [],
                                        dataTitle: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <Button
                                type="primary"
                                style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                onClick={this.onFillLastMonth}
                            >填充上月数据</Button>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Table1 data={this.state.data1} dataTitle={this.state.dataTitle} onChange={this.onChildChange} print={this.state.print} />
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>9.4.3 Please provide the action plan on the variance. 请提供针对以上差异的后续跟进报告。</Row>
                            {!this.state.loading || this.state.print ? <TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_4">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-4/index.js